module.exports=require('./lib/vue2-countdown.vue')



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue2-countdown/index.js
// module id = Lcq9
// module chunks = 0